import React from "react";
import styles from "./DownloadBanner.module.css";
import file1 from "../../assets/pdf/BCPL_Brochure.pdf";
import file2 from "../../assets/pdf/iFillip_Brochure.pdf";
import { FaFilePdf } from "react-icons/fa6";

const DownloadBanner = ({ bannerText }) => {
  const handleDownload = (fileUrl, fileName) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={`container-fluid ${styles.containerFluidBanner} mb-5`}>
      <div className={`${styles.rowBanner} row`}>
        {/* Text */}
        <div className="col-12 col-lg-7 d-flex px-4 px-lg-5 align-items-center">
          <h5 className={`${styles.bannerText} m-0`}>{bannerText}</h5>
        </div>

        {/* Buttons */}
        <div className="col-12 col-lg-5 d-flex justify-content-start justify-content-lg-end px-4 px-lg-5 align-items-start align-items-lg-center gap-5 mt-3 mt-lg-0">
          <a href={file1} download="Bharat Clouds Private Limited" className={styles.downloadLink}>
            <FaFilePdf  size={20} color="#142454" />
            <span>Company Profile</span>
          </a>

          <a href={file2} download="IFILLIP" className={styles.downloadLink}>
            <FaFilePdf size={20} color="#142454" />
            <span>iFillip Brochure</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadBanner;
